import { TagColorType } from "components/DesignSystem/Tag/Tag";

// Mirrors messaging.choices.EmailSuppressionReasonChoices on the Django backend.
export const SUPPRESSION_REASON_HARD_BOUNCE = 0;
export const SUPPRESSION_REASON_SPAM_COMPLAINT = 1;
export const SUPPRESSION_REASON_MANUAL_SUPPRESSION = 2;

export type SuppressionReason =
  | typeof SUPPRESSION_REASON_HARD_BOUNCE
  | typeof SUPPRESSION_REASON_SPAM_COMPLAINT
  | typeof SUPPRESSION_REASON_MANUAL_SUPPRESSION;

type SuppressionReasonDetails = {
  label: string;
  tagType: TagColorType;
  isRisky: boolean;
};

const SUPPRESSION_REASON_DETAILS: Record<
  SuppressionReason,
  SuppressionReasonDetails
> = {
  [SUPPRESSION_REASON_HARD_BOUNCE]: {
    label: "Hard bounce",
    tagType: "orange",
    isRisky: false,
  },
  [SUPPRESSION_REASON_SPAM_COMPLAINT]: {
    label: "Spam complaint",
    tagType: "red",
    isRisky: true,
  },
  [SUPPRESSION_REASON_MANUAL_SUPPRESSION]: {
    label: "Manually suppressed",
    tagType: "gray",
    isRisky: true,
  },
};

const UNKNOWN_SUPPRESSION_REASON_DETAILS: SuppressionReasonDetails = {
  label: "Unknown reason",
  tagType: "gray",
  isRisky: true,
};

export function getSuppressionReasonDetails(
  reason: number | null
): SuppressionReasonDetails {
  if (reason === null) return UNKNOWN_SUPPRESSION_REASON_DETAILS;
  return (
    SUPPRESSION_REASON_DETAILS[reason as SuppressionReason] ??
    UNKNOWN_SUPPRESSION_REASON_DETAILS
  );
}
